import {
  COMPANIES_DATA
} from '../actions/types';

const initialState = {
  data: []
};

export default function CompaniesReducer(state = initialState, action = {
  type: undefined
}) {
  switch (action.type) {
    case COMPANIES_DATA:
      return { ...state, ...action.playload };
    default:
      return { ...state };
  }
}
